import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const payload = parseToMutationRequest(data, ['bonusPeriodUnit', 'amount', 'index']);
  const createEmployeeBonus = `createEmployeeBonus(input: ${payload})`;
  return gql`
  mutation {
    ${createEmployeeBonus} {
      id
    }
  }
`;
};
